import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 20.004 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "var(--stroke-0, #66492F)",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", { d: "M11.62 20.367a2.37 2.37 0 0 1-1.618.633 2.37 2.37 0 0 1-1.617-.633C4.414 16.626-.908 12.447 1.687 6.38 3.092 3.1 6.46 1 10.003 1s6.912 2.1 8.315 5.38c2.592 6.06-2.717 10.259-6.698 13.987Z" }),
      _createElementVNode("path", { d: "M13.502 10a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })
    ], -1)
  ]))]))
}
export default { render: render }